import { render, staticRenderFns } from "./ViewPendingInvoices.vue?vue&type=template&id=9fbc7b04&scoped=true&"
import script from "./ViewPendingInvoices.vue?vue&type=script&lang=js&"
export * from "./ViewPendingInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbc7b04",
  null
  
)

export default component.exports